import { ResendOtpResponse } from '@porterin/booking-flow/src/auth/domain/api-models/ResendOtpApiModel';
import { ResendOtp } from '@porterin/booking-flow/src/auth/domain/entities/ResendOtp';
import { toResendOtpEntity } from '@porterin/booking-flow/src/auth/domain/entity-mappers/ResendOtpEntityMapper';
import {
  createHeaders,
  createNetworkError,
  getValidateOtpRequestUrl,
} from '@porterin/booking-flow/src/auth/domain/helpers/authHelpers';
import { fireApiErrorSentry } from '@porterin/component-library/src/ts-utils/analytics/sentry/SentryHelpers';
import axios, { AxiosError } from 'axios';

import { ResendOtpOption } from '../entities/ResendOtpOption';

export const resendOtp = async (
  webTrackingId: string,
  mobile: string,
  option: ResendOtpOption,
): Promise<ResendOtp> => {
  try {
    const headers = createHeaders(webTrackingId);
    const payload = { mobile };

    const response = await axios.post<ResendOtpResponse>(
      `${getValidateOtpRequestUrl(option)}`,
      payload,
      { headers },
    );

    return toResendOtpEntity(response.data);
  } catch (error) {
    fireApiErrorSentry(error, 'resendOtp');
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError;
      throw createNetworkError(
        axiosError.response?.status ?? 500,
        axiosError.message,
      );
    }
    throw error;
  }
};
